/* eslint-disable array-callback-return, eqeqeq */
import React, {
    useState,
    useEffect
} from "react";

import { sortableContainer, sortableElement, sortableHandle } from 'react-sortable-hoc';
import arrayMove from 'array-move';
import Highcharts from 'highcharts/highstock';
import HighchartsReact from 'highcharts-react-official';
import HighchartsMore from 'highcharts/highcharts-more';
import { get_chart_options } from '../../options/tv_index';
import Button from '@material-ui/core/Button';
import ReactTooltip from 'react-tooltip';
import icon_info from "assets/images/icon-info.png";

HighchartsMore(Highcharts);

const TvCharts = (props) => {
    const {
        Highstock,
        selected_tv_kpis,
        tv_analytics,
        zoom_type,
        kpi_names,
        update_extremes,
        sorted_tv_kpis,
        set_sorted_tv_kpis,
        customTimeRange,
        setCustomTimeRange,
        night_view,
        vital_parameters,
        show_plotbands
    } = props;
    const [zoomType, set_zoom_type] = useState(zoom_type);

    const tooltip_text = {
        BR: "Breathing rate of a subject estimated by the radar signal",
        HR: "Heart Rate Radar calculated from radar signal using Sleepiz algorithm",
        SPO2: "Blood oxygen saturation measured by the SPO2 sensor connected to the Sleepiz device",
        PR: "Pulse Rate measured by SPO2 sensor connected to the Sleepiz Device",
        SQ: "Different time durations in hour indicating overall quality of the recording, e.g good signal duration, total time in bed, total recording time, total breathing time",
        RII: "Respiratory Irregularity Index calculated as total number of irregularly events per hour of total sleep time",
        SE: "Sleep efficiency i.e ratio of total sleep time with total time in bed.",
    };

    useEffect(() => {
        onClickResetZoom();
    }, [night_view]);

    const configure_charts = () => {
        ['mousemove', 'touchmove', 'touchstart'].forEach(function (eventType) {
            const charts = document.getElementById('charts');

            if (charts) {
                charts.addEventListener(
                    eventType,
                    function (e) {
                        let point,
                            i,
                            event;

                        for (i = 0; i < Highstock.charts.length; i = i + 1) {
                            let chart = Highstock.charts[i];
                            if (chart && chart.pointer) {
                                // Find coordinates within the chart
                                event = chart.pointer.normalize(e);
                                // Get the hovered point
                                point = chart.series[0].searchPoint(event, true);

                                if (point && point.highlight) {
                                    point.highlight(e);
                                }
                            }
                        }
                    }
                );
            }
        });
    }

    useEffect(configure_charts, []);

    const sliderChangeHandler = () => {
        setTimeout(() => {
            setCustomTimeRange([max, min]);
        }, 10);
    }

    useEffect(() => {
        const charts = document.getElementById("time-range-slider");
        if (charts) {
            charts.addEventListener("mouseup", sliderChangeHandler);
            return () => { charts.removeEventListener("mouseup", sliderChangeHandler) };
        }
    }, []);
    const keyboardNavigation = (e) => {
        if (e.keyCode == 37) {
            navigateGraphToLeft();
        }
        else if (e.keyCode == 39) {
            navigateGraphToRight();
        }
    }
    useEffect(() => {
        const charts = document.getElementById("time-range-slider");
        if (charts) {
            charts.addEventListener('keydown', sliderDebounce(keyboardNavigation, 500));
            return () => charts.removeEventListener('keydown', sliderDebounce);
        }
    }, []);

    var max = ""; var min = "";
    function syncExtremes(e) {
        var thisChart = this.chart;

        if (e.trigger !== 'syncExtremes') {
            // Prevent feedback loop
            Highstock.each(Highstock.charts, function (chart) {
                update_extremes({
                    from: e.min,
                    to: e.max
                });
                max = e.max;
                min = e.min;
                if (chart !== thisChart) {
                    if (chart && chart.xAxis && chart.xAxis[0].setExtremes) {
                        chart.xAxis[0].setExtremes(
                            e.min,
                            e.max,
                            undefined,
                            false,
                            { trigger: 'syncExtremes' }
                        );
                    }
                }
            });
        }
    }

    const get_charts = () => {
        const charts_elements = sorted_tv_kpis.map((kpi_id, index) => {
            if (!Object.keys(selected_tv_kpis).find(k => k === kpi_id)) {
                return null;
            }

            if (selected_tv_kpis && selected_tv_kpis[kpi_id] && tv_analytics[kpi_id]) {
                return (
                    <SortableItem key={`item-${kpi_id}`} index={index} kpi_id={kpi_id} expandedClass={"expanded"} />
                )
            }

            return null;
        });

        return charts_elements;
    }

    const onSortEnd = ({ oldIndex, newIndex }) => {
        if (selected_tv_kpis && Object.keys(selected_tv_kpis).length > 1) {
            set_sorted_tv_kpis(arrayMove(sorted_tv_kpis, oldIndex, newIndex));
        }
    };

    const SortableContainer = sortableContainer(({ children }) => (
        <ul className="charts-wrap" id="charts">{children}</ul>
    ));

    const DragHandle = sortableHandle(() => <span title="Drag" className="icon drag-icon">::</span>);

    const SortableItem = sortableElement(({ kpi_id, expandedClass }) => {
        let noData = false;
        if (tv_analytics[kpi_id] && tv_analytics[kpi_id] && tv_analytics[kpi_id].length === 0) {
            noData = true;
        }

        return (
            <li key={'chart-div-block-' + kpi_id} className={"chart-block " + expandedClass} id={`chart-${kpi_id}`}>
                <div className="chart-details expanded-chart-details">
                    <div className="chart-details-left">
                        <DragHandle />
                        <ReactTooltip id='tooltip-drag' className='graph-tooltip' place="bottom">
                                
                        </ReactTooltip>
                        <span className="graph-title">{kpi_id === 'MOV' ? "Restlessness" : kpi_names[kpi_id]}</span>
                        <span className="icon info-icon" data-tip data-for={`'tooltip-${kpi_id}'`} ><img src={icon_info} alt="Icon" /></span>
                    </div>
                </div>
                {
                    noData &&
                    <div className="no-data-kpi-block">
                        <span className="no-data-kpi-block-content">No data available for {kpi_id === 'MOV' ? "Restlessness" : kpi_names[kpi_id]}.</span>
                    </div>
                }
                {
                    !noData
                    && <HighchartsReact
                        kpi_name={kpi_names[kpi_id]}
                        allowChartUpdate={true}
                        key={kpi_id}
                        highcharts={Highstock}
                        constructorType="stockChart"
                        containerProps={{ className: 'chart-container-wrap', id: "chart-kpi-" + kpi_id }}
                        options={get_chart_options({
                            kpi_id,
                            syncExtremes,
                            tv_analytics: tv_analytics[kpi_id],
                            zoom_type: zoomType,
                            customTimeRange,
                            setCustomTimeRange,
                            vital_parameters,
                            show_plotbands
                        })}
                    />
                }
                <div className="chart-details collapse-chart-details">
                    <div className="chart-details-right">
                        <span className="icon info-icon" data-tip data-for={`'tooltip-${kpi_id}'`} ><img src={icon_info} alt="Icon" /></span>
                        <span title={zoomType === 'xy' ? "X-axis Zoom" : 'XY-axis Zoom'} className={"Y-Zoom"}>
                            {zoomType === 'xy' && <button className = "button" onClick={() => {set_zoom_type('x'); console.log("clicked")}} > X</button>}
                            {zoomType === 'x' && <button className = "button" onClick={() => {set_zoom_type('xy'); console.log("clicked")}} > XY</button>}
                        </span>
                    </div>
                </div>
                <ReactTooltip id={`'tooltip-${kpi_id}'`} className='graph-tooltip' place="bottom">
                    {tooltip_text[kpi_id]}
                </ReactTooltip>
            </li>
        );
    });

    const sliderDebounce = (func, delay) => {
        let debounceTimer
        return function () {
            const context = this
            const args = arguments
            clearTimeout(debounceTimer)
            debounceTimer
                = setTimeout(() => func.apply(context, args), delay)
        }
    }

    const onClickResetZoom = () => {
        const charts = Highstock.charts.filter(chart => {
            if (chart) {
                return true;
            } else {
                return false;
            }
        });

        charts.map(chart => {
            if (chart && chart.navigator) {
                chart.zoomOut();
                set_zoom_type('x');
                update_extremes({
                    from: chart.navigator.chart.xAxis[0].min,
                    to: chart.navigator.chart.xAxis[0].max
                });
            }
        });
    }

    const navigateGraphToLeft = () => {
        const charts = Highstock.charts.filter(c => c && c.renderTo.id === "time-range-slider");

        charts.map(chart => {
            if (chart && chart.navigator) {
                const selectedRange = chart.navigator.chart.xAxis[0].max - chart.navigator.chart.xAxis[0].min;

                let min = chart.navigator.chart.xAxis[0].min - selectedRange;
                let max = chart.navigator.chart.xAxis[0].min;

                if (min <= chart.xAxis[1].min) {
                    min = chart.xAxis[1].min;
                }

                if (max <= chart.xAxis[1].min) {
                    max = chart.navigator.chart.xAxis[0].max;
                }

                chart.xAxis[0].setExtremes(min, max);
                setCustomTimeRange([max, min]);

            }
        });
    };

    const navigateGraphToRight = () => {
        const charts = Highstock.charts.filter(c => c && c.renderTo.id === "time-range-slider");

        charts.map(chart => {
            if (chart && chart.navigator) {
                const selectedRange = chart.navigator.chart.xAxis[0].max - chart.navigator.chart.xAxis[0].min;

                let min = chart.navigator.chart.xAxis[0].max;
                let max = chart.navigator.chart.xAxis[0].max + selectedRange;

                if (max >= chart.xAxis[1].max) {
                    max = chart.xAxis[1].max;
                }

                if (min >= chart.xAxis[1].max) {
                    min = chart.navigator.chart.xAxis[0].min;
                }

                chart.xAxis[0].setExtremes(min, max);
                setCustomTimeRange([max, min]);
            }
        });
    };

    const getTimeRangeSelector = () => {
        if (selected_tv_kpis && Object.keys(selected_tv_kpis).length > 0 && tv_analytics && tv_analytics[Object.keys(selected_tv_kpis)[0]]) {
            let totalData = 0;
            let kpi_slider;
            Object.keys(selected_tv_kpis).map(k => {
                if (tv_analytics && tv_analytics[k] && tv_analytics[k].length > 0) {
                    totalData += tv_analytics[k].length;
                    kpi_slider = k;
                }
            });

            if (totalData === 0) {
                return '';
            }

            const kpi_id = kpi_slider;
            const options = {
                rangeSelector: {
                    enabled: false
                },
                tooltip: {
                    enabled: false
                },
                yAxis: {
                    height: 0,
                    gridLineWidth: 0,
                    labels: {
                        enabled: false,
                    }
                },
                xAxis: {
                    lineWidth: 1,
                    lineColor: 'rgba(60, 60, 60, 0.3)',
                    gridLineColor: 'rgba(60, 60, 60, 0.3)',
                    tickLength: 0,
                    offset: 35,
                    labels: {
                        enabled: false,
                        align: 'center'
                    },
                },
                plotOptions: {
                    series: {
                        marker: {
                            enabled: false
                        }
                    },
                    line: {
                        marker: {
                            enabled: false
                        }
                    }
                },
                navigator: {
                    enabled: true,
                    maskFill: 'rgba(143, 189, 233, 0.25)',
                    outlineColor: '#1E87D7',
                    outlineWidth: 0,
                    height: 44,
                    xAxis: {
                        ordinal: false,
                        labels: {
                            align: 'center',
                            y: 11,
                            style: {
                                fontFamily: 'Avenir'
                            },
                        },
                    },
                },
                scrollbar: {
                    enabled: false
                },
                credits: {
                    enabled: false,
                }
            }

            let dataset = get_chart_options({
                kpi_id,
                syncExtremes,
                tv_analytics: tv_analytics[kpi_id],
                zoom_type,
                height: 60
            });

            if(dataset) {
                dataset.rangeSelector = { ...dataset.rangeSelector, ...options.rangeSelector };
                dataset.tooltip = { ...dataset.tooltip, ...options.tooltip };
                dataset.yAxis = { ...dataset.yAxis, ...options.yAxis };
                dataset.xAxis = { ...dataset.xAxis, ...options.xAxis };
                dataset.plotOptions = { ...dataset.plotOptions, ...options.plotOptions };
                dataset.navigator = { ...dataset.navigator, ...options.navigator };
                dataset.scrollbar = { ...dataset.scrollbar, ...options.scrollbar };
            }

            return (
                <div className="tv-range-slider-wrap">
                    <HighchartsReact
                        allowChartUpdate={true}
                        key={"time-range-navigator"}
                        highcharts={Highstock}
                        constructorType="stockChart"
                        options={dataset}
                        containerProps={{ className: "range-slider-block", id: "time-range-slider", tabIndex: "1" }}
                    />
                    <div className="range-select-wrap">
                        <Button
                            disableRipple={true}
                            disableFocusRipple={true}
                            className="custom-button"
                            onClick={onClickResetZoom}
                        >Reset Zoom</Button>
                        <div className="range-arrows">
                            <span tabIndex="1" className="zmdi zmdi-chevron-left zmdi-hc-fw" onKeyDown={(e) => { e.persist(); if (e.keyCode == 37) { keyboardNavigation(e) } }} onClick={navigateGraphToLeft}></span>
                            <span tabIndex="1" className="zmdi zmdi-chevron-right zmdi-hc-fw" onKeyDown={(e) => { e.persist(); if (e.keyCode == 39) { keyboardNavigation(e) } }} onClick={navigateGraphToRight}></span>
                        </div>
                    </div>
                </div>
            );
        }
    }

    return (
        <>
            <SortableContainer distance={10} lockToContainerEdges={true} onSortEnd={onSortEnd} useDragHandle={true}>
                {get_charts()}
            </SortableContainer>
            {getTimeRangeSelector(zoomType)}
        </>
    )
}

export default React.memo(TvCharts, (prevProps, nextProps) => {
    return (
        (document.getElementById('charts') && Object.values(nextProps.selected_tv_kpis).length == document.getElementById('charts').children.length)
        && prevProps.sorted_tv_kpis == nextProps.sorted_tv_kpis
        && prevProps.show_plotbands == nextProps.show_plotbands
    );
});
